import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const PriceForMeterFieldContainer: React.FC = () => {
  const { price, published } = useOfferContext();

  const priceForMeter = price && price.forMeter;

  if (priceForMeter) {
    return <TextField published={published}>{priceForMeter}</TextField>;
  }

  return <EmptyField published={published} />;
};
